var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcaseIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 91.1429 91.1429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bag-suitcase-2--product-business-briefcase"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M82.7143 19.5714H8.42857C4.32592 19.5714 1 22.8973 1 27V82.7143C1 86.8171 4.32592 90.1429 8.42857 90.1429H82.7143C86.8171 90.1429 90.1429 86.8171 90.1429 82.7143V27C90.1429 22.8973 86.8171 19.5714 82.7143 19.5714Z",
    stroke: "url(#paint0_linear_0_17)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M64.1429 19.5714V8.42857C64.1429 6.45837 63.3602 4.56891 61.9671 3.17575C60.5739 1.78267 58.6845 1 56.7143 1H34.4286C32.4584 1 30.5689 1.78267 29.1758 3.17575C27.7827 4.56891 27 6.45837 27 8.42857V19.5714",
    stroke: "url(#paint1_linear_0_17)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_17",
    x1: 89.1299,
    y1: 54.2787,
    x2: -48.1354,
    y2: 112.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_17",
    x1: 63.7208,
    y1: 10.1335,
    x2: 17.2481,
    y2: 41.4178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseIllustration);
export default __webpack_public_path__ + "static/media/briefcase_illustration.728550b9b215d28db28f97c498b68912.svg";
export { ForwardRef as ReactComponent };